export const kOperationItemsPerPage = 7
export const APIuri = '/api'